import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import * as user from 'store/slices/user';
import type {Organization} from 'store/slices/user/types';
import {useFetchOrgMembers} from './useFetchOrgMembers';

export function useOrgMembers(organization?: Organization) {
  const {getMembers, loading, error} = useFetchOrgMembers();

  const members = useSelector(
    user.selectors.getMembersByOrganization(organization?.id),
  );

  useEffect(() => {
    if (organization) {
      getMembers(organization?.domain, organization?.id);
    }
  }, [organization?.id]);

  return {members, loading, getMembers, error};
}
